<template>
  <Container>
    <div
      class="
        grid grid-cols-2 gap-15
        lg:grid-cols-3
      "
    >
      <!-- MAIN CONTENT -->
      <div class="col-span-2">
        <div>
          <!-- Do not show breadcrumbs on home page -->
          <Breadcrumbs v-if="route.params.uri" />

          <LoaderHeros :heros="page.main_heros" />
        </div>

        <LoaderComponents
          v-editor-target="'main_components'"
          :components="page.main_components"
        />
      </div>

      <!-- SIDEBAR -->
      <div class="max-lg:col-span-2">
        <Sidebar :data="page.sidebar_components" />
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { BlueprintPageFragment } from '#gql'

defineProps<{ page: Enforce<BlueprintPageFragment> }>()

const route = useRoute()
</script>
